import { Pipe, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { PipeTransform } from '@angular/core';

/**
 * Formats boolean value as YES/NO
 */
@Pipe({
  name: 'tdWbBoolean'
})
export class BooleanPipe implements PipeTransform {
  private readonly translateService = inject<TranslateService>(TranslateService);

  transform(value: boolean | undefined | null): string | undefined | null {
    if (value === true) {
      return this.translateService.instant('tdWb.core.pipes.bool.YES');
    }
    if (value === false) {
      return this.translateService.instant('tdWb.core.pipes.bool.NO');
    }
    return value;
  }

}
